import { render, staticRenderFns } from "./ConfirmDeleteDialog.vue?vue&type=template&id=1d0c6f4c&scoped=true"
import script from "./ConfirmDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmDeleteDialog.vue?vue&type=style&index=0&id=1d0c6f4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0c6f4c",
  null
  
)

export default component.exports